import CoreuiVue from '@coreui/vue'

export default CoreuiVue
